
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/external/leadPage/[pageCode]",
      function () {
        return require("private-next-pages/external/leadPage/[pageCode].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/external/leadPage/[pageCode]"])
      });
    }
  